import { useGetThresholdsForChartQuery } from "@madmedical/threshold";
import { usePatientId } from "@madmedical/user";
import { ChartWidget } from "@madmedical/ui";
export default (metricType, widget) => {
    var _a;
    const { patientId } = usePatientId();
    const { data } = useGetThresholdsForChartQuery({ patientId, metricType }, { skip: widget !== ChartWidget.Page });
    return ((_a = data === null || data === void 0 ? void 0 : data.map(({ alertThreshold, title }) => ({
        limit: alertThreshold,
        title,
    }))) !== null && _a !== void 0 ? _a : []);
};
